"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const i18n_js_1 = __importDefault(require("i18n-js"));
const material_1 = require("@mui/material");
const InfoOutlined_1 = __importDefault(require("@mui/icons-material/InfoOutlined"));
const ErrorBox = styled_components_1.default.div `
  max-width: 1024px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  svg {
    width: 50px;
    height: 50px;
  }

  p {
    font-size: 2.5vmin;
    padding: 2.1vmin 0;
    margin: 3vmin 0 7vmin;
  }

  .ok-button {
    background-color: #33b5e5;
    color: #fff;
    padding: 1vmin 12vmin;
    font-size: 1.8vmin;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }
`;
const BookingNotice = styled_components_1.default.div `
  background-color: #fff0c2;
  border: 1px solid #f6df96;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  gap: 10px;
  color: #2a2522;
`;
const BookingLimitsErrorOrNotice = ({ bookingMessage, isError = false, }) => {
    const history = (0, react_router_dom_1.useHistory)();
    if (isError) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ErrorBox, { "data-testid": "booking-error" },
                react_1.default.createElement("img", { src: "/images/other/cancel.svg", alt: "Cancel" }),
                react_1.default.createElement(material_1.Typography, null,
                    " ",
                    bookingMessage,
                    " "),
                react_1.default.createElement(material_1.Button, { className: "ok-button", onClick: () => history.goBack(), "data-testid": "ok" }, i18n_js_1.default.t('ok')))));
    }
    return (react_1.default.createElement(BookingNotice, { "data-testid": "booking-notice" },
        react_1.default.createElement(InfoOutlined_1.default, null),
        bookingMessage));
};
exports.default = BookingLimitsErrorOrNotice;
